<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="notifyTitle" label="通知标题"></el-table-column>
            <el-table-column prop="notifyContent" label="通知内容" width="500"></el-table-column>
            <el-table-column prop="productName" label="代卖钱币">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover">
                        <el-image style="width: 300px; height: 300px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover"></el-image>
                        <el-button type="text" slot="reference">{{ scope.row.productName }}</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="productAppraisal" label="评级编码"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.notifyDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="productImages" label="钱币底图">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover" :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages.split(',').length > 1"
                            style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 16px; height: 16px; line-height: 16px; text-align: center; color: #FFFFFF; font-size: 10px; border-radius: 50%;">
                            {{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import scheduleMixin from "@/mixins/schedule-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, imageMixin, enumMixin, scheduleMixin],
    data: function () {
        return {
            popovers: [],
        }
    },
    methods: {
        
    },
    created: async function () {
        this.tag = "NOTIFY";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>